/**
 * Badge.js
 * Created by RSargunan on 8/7/2020.
 */

import React from 'react';
import MotifBadge from '@ey/motif-react-wrapper/Badge';
import styled from 'styled-components';

export default function Badge(props) {
	const {variant, count, isOverlap} = props,
		countValue = count ? count : 0;

	return <StyledMotifBadge variant={variant} value={countValue} overlap={isOverlap} />;
}

const StyledMotifBadge = styled(MotifBadge)``;
